import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function normalizeCoords(
  coords: { lat: number; lng: number }[]
): { lat: number; lng: number }[] {
  return coords.map((c) => ({
    lat: c.lat,
    lng: c.lng > 180 ? c.lng - 360 : c.lng,
  }));
}
